import { useState } from "react"
import { Outlet } from "react-router-dom"
import LoginBar from "./LoginBar"
import ErrorBoundary from "./ErrorBoundary/ErrorBoundary"
import Footer from "./Footer"



export default function MainLayout() {


    return (
        <>  
            <ErrorBoundary>
                <LoginBar />
            </ErrorBoundary>
            <main>
                <Outlet />
            </main>
            <ErrorBoundary>
                <Footer />
            </ErrorBoundary>
        </>
    )
}